import React from "react";

function Learning(){
    return(
        <section className="learning" id="learning">
        <h2 data-aos="fade-up" data-aos-duration="700">What I'm Learning Now</h2>
        <div className="summary">
        <div data-aos="fade-up" data-aos-duration="700">
          <p>I'm currently expanding my knowledge in project management by working on the Google Project Management Certification to enhance my skills in planning, organizing, and delivering successful projects. I will eventually work towards the CAPM and PMP.</p>
          <p>Additionally, I’ll soon dive into SQL to strengthen my technical toolkit and improve my data management and analysis capabilities.</p>
          
        </div>
        </div>
      </section>
    );
}

export default Learning;
